import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M18 19H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zm1-16H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z",
    fillRule: "evenodd"
  }],
  circles: []
};
var CheckBoxOutlineBlankIcon = function CheckBoxOutlineBlankIcon(props) {
  return renderIcon(props, iconType);
};

export { CheckBoxOutlineBlankIcon };
//# sourceMappingURL=CheckBoxOutlineBlankIcon.esm.js.map
